// 商品券催用 AB实验 https://abtest-sgp.corp.kuaishou.com/ab2#/experiment/analysis/6775/detail?tab=2&docType=12&isShared=true

export const ThemeColorMap = {
    product: {
        background: '#FF49060D',
        text: '#FF4906',
        btnBorder: 'rgba(255, 73, 6, 0.12)',
        border: 'rgba(255, 73, 6, 0.14)',
        cornorBackground: '#FFE1D6',
    },
    shipping: {
        background: '#F0F6F6',
        text: '#4CA7A2',
        btnBorder: 'rgba(76, 167, 162, 0.20)',
        border: '#4CA7A233',
        cornorBackground: '#E4F2F1',
    },
};

export function useCouponPush() {
    // const state = useFirstScreenAB();

    return {
        couponPush: {
            productCouponPriority: true, // 已推全 true
            couponUsePrompt: true, // 催用 已推全 true
            init: true,
        },
    };
}
